import { accountIdFormat } from "@redotech/redo-account-id";
import { consolidationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";
import { cartonOperationIdSchema } from "./carton-operation";

export const previewConsolidationCartonAttachment = {
  name: "previewConsolidationCartonAttachment" as const,
  input: z.object({
    consolidationId: consolidationIdFormat.schema,
    cartonId: cartonOperationIdSchema,
  }),
  output: z.object({
    alreadyAttached: z.boolean(),
    cartonId: cartonOperationIdSchema,
    displayIdentifier: z.string(),
    ownerAccountId: accountIdFormat.schema.nullable(),
    ownerName: z.string().nullable(),
    storageLocationName: z.string().nullable(),
    quantity: z.number().int().nonnegative(),
    revision: z.string(),
  }),
};
export type CartonAttachmentCandidate = z.infer<
  typeof previewConsolidationCartonAttachment.output
>;
